"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { DropdownPickerButton } from "@/components/molecules/dropdown-picker-button/DropdownPickerButton";
import { PortfolioUnitGrid } from "@/components/molecules/portfolio-unit-grid/PortfolioUnitGrid";
import type { PortfolioRoomsResult } from "@/components/modules/portfolio/hooks/usePortfolioUtils";
import type { BusinessUnitsSchemaType, GetRealEstateManagementSchemaType } from "@/components/modules/portfolio/api/schemas/schemas";
type Props = {
  resource: PortfolioRoomsResult;
  /** Currently associated unit, if any. */
  value?: {
    unitId?: string;
    unitTitle?: string;
    portfolioTitle?: string;
  };
  onChange: (selection: {
    unit: BusinessUnitsSchemaType;
    portfolio: GetRealEstateManagementSchemaType;
  }) => void;
  /** When provided, an inline X button appears once a selection exists. */
  onClear?: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  variant?: "default" | "primary";
};
export function PortfolioRoomPicker(t0) {
  const $ = _c(22);
  const {
    resource,
    value,
    onChange,
    onClear,
    placeholder,
    className,
    disabled,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t = useTranslations("modules.portfolio.associateListingToUnit");
  const t2 = value?.portfolioTitle;
  const t3 = value?.unitTitle;
  let t4;
  if ($[0] !== placeholder || $[1] !== t) {
    t4 = placeholder ?? t("dialogTitle");
    $[0] = placeholder;
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t) {
    t5 = t("dialogTitle");
    $[3] = t;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("dialogDescription");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onChange || $[8] !== resource || $[9] !== value?.unitId) {
    t7 = t8 => {
      const {
        close
      } = t8;
      return <PortfolioUnitGrid resource={resource} selectedUnitId={value?.unitId} onSelectUnit={(unit, portfolio) => {
        onChange({
          unit,
          portfolio
        });
        close();
      }} />;
    };
    $[7] = onChange;
    $[8] = resource;
    $[9] = value?.unitId;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== className || $[12] !== disabled || $[13] !== onClear || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== variant) {
    t8 = <DropdownPickerButton label={t2} sublabel={t3} placeholder={t4} dialogTitle={t5} dialogDescription={t6} onClear={onClear} variant={variant} className={className} disabled={disabled} data-sentry-element="DropdownPickerButton" data-sentry-component="PortfolioRoomPicker" data-sentry-source-file="PortfolioRoomPicker.tsx">{t7}</DropdownPickerButton>;
    $[11] = className;
    $[12] = disabled;
    $[13] = onClear;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = variant;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}